<template>
  <div class="offers-page">

    <div class="offers-page-header">
      <offers-page-header/>
    </div>

    <div class="offers-body">
      <offers-body />
    </div>

  </div>

</template>

<script>
import OffersPageHeader from "@/features/offers/OffersPageHeader.vue";
import OffersBody from "@/features/offers/OffersBody.vue";

export default {
  name: "OffersPage",
  components: {OffersPageHeader, OffersBody},

}
</script>

<style scoped>
.offers-page{
  height: 100%;
}

</style>